import { apiGet, apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useForm, Controller } from "react-hook-form";
import ErrorMessage from "components/ErrorMessage";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React, { useCallback, useEffect, useState } from "react";

const EditFAQ = ({ setEditShowModal, getAllFAQ, item }) => {
  const { t } = useTranslation();
  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      title: item?.title,
      titleAr: item?.titleAr,
      content: item?.content,
      contentAr: item?.contentAr,
      projectId: item?.projectId,
      category: item?.category,
      showInWebsite: item?.showInWebsite ?? true,
      showInAgentApp: item?.showInAgentApp ?? true,
      showInCustomerApp: item?.showInCustomerApp ?? true,
    },
  });
  const notification = useToastContext();

  const onSubmit = async (data) => {
    try {
      const path = apiPath.getFAQs + "/" + item._id;
      data = {
        ...data,
        projectId: [...selectedProject.map((projectId) => projectId)],
        category: selectedCategory,
      };
      const result = await apiPut(path, data);
      if (result?.status === 200) {
        notification.success(result?.data?.message);
        getAllFAQ();
        setEditShowModal(false);
      }
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  };
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(
    Array.isArray(item?.projectId)
      ? item.projectId.map((project) => project._id ?? project)
      : item?.projectId
      ? [item.projectId._id ?? item.projectId]
      : [],
  );
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(
    Array.isArray(item?.category)
      ? item.category.map((category) => category)
      : item?.category
      ? [item.category]
      : [],
  );
  const getProjects = useCallback(async () => {
    try {
      const payload = {};
      const path = apiPath.projectPath + "/all-projects";
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      setProjects(records ?? []);
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  }, []);

  const getCategories = useCallback(async () => {
    try {
      const path = apiPath.getFAQsCategories;
      const response = await apiGet(path);
      console.log("response", response);
      setCategories(response?.data?.results);
    } catch (error) {
      console.error("error in get categories==>>>>", error.message);
    }
  }, []);

  useEffect(() => {
    setValue("projectId", selectedProject);
  }, [selectedProject, setValue]);

  useEffect(() => {
    getProjects();
    getCategories();
  }, [getProjects]);

  const selectedProjectOptions = projects.filter((p) =>
    selectedProject.includes(p._id),
  );

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="sm:py-4 sm:px-2 py-8 px-7"
          >
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("FAQS_EDIT_FAQS")}</h3>
                <button
                  className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => setEditShowModal(false)}
                >
                  <span className=" text-[#B8BBBF]  text-4xl ">×</span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-1">
                  <div className="mb-6 relative w-full">
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      id="faq-edit-project-autocomplete"
                      options={projects}
                      getOptionLabel={(option) => option?.title ?? ""}
                      isOptionEqualToValue={(option, value) =>
                        option._id === value._id
                      }
                      value={selectedProjectOptions}
                      onChange={(event, newValue) => {
                        setSelectedProject(newValue.map((p) => p._id));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("SELECT_PROJECT")}
                          placeholder={t("SELECT_PROJECT")}
                          size="small"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "rgb(249 250 251)",
                            },
                          }}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.projectId?.message} />
                  </div>
                  <div className="mb-6 w-full px-2">
                    <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      {t("FAQS_VISIBILITY")}
                    </p>
                    <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-6">
                      <Controller
                        name="showInWebsite"
                        control={control}
                        render={({ field }) => (
                          <label className="inline-flex items-center gap-2 cursor-pointer text-sm text-gray-900 dark:text-white">
                            <input
                              type="checkbox"
                              className="w-4 h-4 rounded border-gray-300 text-[#8FC150] focus:ring-[#8FC150]"
                              checked={!!field.value}
                              onChange={(e) => field.onChange(e.target.checked)}
                            />
                            {t("FAQ_SHOW_WEBSITE")}
                          </label>
                        )}
                      />
                      <Controller
                        name="showInAgentApp"
                        control={control}
                        render={({ field }) => (
                          <label className="inline-flex items-center gap-2 cursor-pointer text-sm text-gray-900 dark:text-white">
                            <input
                              type="checkbox"
                              className="w-4 h-4 rounded border-gray-300 text-[#8FC150] focus:ring-[#8FC150]"
                              checked={!!field.value}
                              onChange={(e) => field.onChange(e.target.checked)}
                            />
                            {t("FAQ_SHOW_AGENT_APP")}
                          </label>
                        )}
                      />
                      <Controller
                        name="showInCustomerApp"
                        control={control}
                        render={({ field }) => (
                          <label className="inline-flex items-center gap-2 cursor-pointer text-sm text-gray-900 dark:text-white">
                            <input
                              type="checkbox"
                              className="w-4 h-4 rounded border-gray-300 text-[#8FC150] focus:ring-[#8FC150]"
                              checked={!!field.value}
                              onChange={(e) => field.onChange(e.target.checked)}
                            />
                            {t("FAQ_SHOW_CUSTOMER_APP")}
                          </label>
                        )}
                      />
                    </div>
                  </div>
                  <Autocomplete
                    multiple
                    options={categories}
                    getOptionLabel={(option) => option.title || ""}
                    value={categories.filter((category) =>
                      selectedCategory.includes(category._id),
                    )}
                    onChange={(_, newValue) => {
                      setSelectedCategory(
                        newValue.map((category) => category._id),
                      );
                    }}
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("SELECT_CATEGORY")}
                        placeholder={t("SELECT_CATEGORY")}
                      />
                    )}
                  />
                  <div>
                    <div className="sm:py-4 sm:px-2 py-8 px-7">
                      <div className="relative z-0 mb-6 w-full group">
                        <input
                          type="text"
                          name="title"
                          id="title"
                          autoFocus
                          maxLength={100}
                          className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                          placeholder=" "
                          {...register("title", {
                            required: "Please enter title.",
                            validate: (value) =>
                              value.trim() ? true : "White spaces not allowed.",
                          })}
                        />
                        <label
                          for="title"
                          className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                          {t("FAQS_TITLE")}
                          <span className="text-red-500">*</span>
                        </label>
                        <ErrorMessage message={errors?.title?.message} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="sm:py-4 sm:px-2 py-8 px-7">
                      <div className="relative z-0 mb-6 w-full group">
                        <input
                          type="text"
                          name="titleAr"
                          id="titleAr"
                          autoFocus
                          maxLength={100}
                          className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                          placeholder=" "
                          {...register("titleAr", {
                            required: "Please enter title in arabic.",
                            validate: (value) =>
                              value.trim() ? true : "White spaces not allowed.",
                          })}
                        />
                        <label
                          for="titleAr"
                          className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                          {t("FAQS_TITLE") + t("O_ARABIC")}
                          <span className="text-red-500">*</span>
                        </label>
                        <ErrorMessage message={errors?.titleAr?.message} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="sm:py-4 sm:px-2 py-8 px-7 w-full">
                      <div className="relative z-0 mb-6 w-full group">
                        <textarea
                          type="text"
                          name="content"
                          id="content"
                          maxLength={200}
                          className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                          placeholder=" "
                          {...register("content", {
                            required: "Please enter content.",
                            validate: (value) =>
                              value.trim() ? true : "White spaces not allowed.",
                          })}
                        />
                        <label
                          for="content"
                          className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                          {t("FAQS_CONTENT")}
                          <span className="text-red-500">*</span>
                        </label>
                        <ErrorMessage message={errors?.content?.message} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="sm:py-4 sm:px-2 py-8 px-7 w-full">
                      <div className="relative z-0 mb-6 w-full group">
                        <textarea
                          type="text"
                          name="contentAr"
                          id="contentAr"
                          maxLength={200}
                          className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                          placeholder=" "
                          {...register("contentAr", {
                            required: "Please enter content in arabic.",
                            validate: (value) =>
                              value.trim() ? true : "White spaces not allowed.",
                          })}
                        />
                        <label
                          for="contentAr"
                          className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                          {t("FAQS_CONTENT") + t("O_ARABIC")}
                          <span className="text-red-500">*</span>
                        </label>
                        <ErrorMessage message={errors?.contentAr?.message} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button
                  className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => setEditShowModal(false)}
                >
                  {t("O_BACK")}
                </button>
                <button
                  className="bg-[#8FC150] text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
                  type="submit"
                  // onClick={(e) => handleSubmit(e)}
                >
                  {t("O_EDIT")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default EditFAQ;
